import Layout from "./components/Layout/Layout";
import AppRoutes from "./AppRoutes";
import { withTranslation } from "react-i18next";
import { themeOptions } from "./stylesheets/Theme";
import { ThemeProvider } from "@emotion/react";
import createTheme from "@mui/material/styles/createTheme";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import InlineOlark, { fixOlarkToBeInline } from "./components/InlineOlark";
import { useSelector } from "react-redux";
import { selectIsInChatPage } from "./store/features/chatSlice";
import { SnackbarProvider } from "notistack";
import "./translations";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

function App() {
  const isInChatPage = useSelector(selectIsInChatPage);
  const navigate = useNavigate();

  useEffect(() => fixOlarkToBeInline("olark-inline-wrapper"), []);

  return (
    <ThemeProvider theme={createTheme(themeOptions)}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider maxSnack={3}>
          <CssBaseline />
          <Layout>
            {/***
             * The InlineOlark (chat) component is rendered here, because of the way Olark react component works.
             * It does not support unmount and remount, and should be rendered only once in the app.
             * The Chat page renders nothing and only controls the "isInChatPage" value.
             */}
            <Box
              id="olark-inline-wrapper"
              display={isInChatPage ? "block" : "none"}
            >
              <IconButton onClick={() => navigate("/")}>
                <ArrowBack />
              </IconButton>
              <InlineOlark />
            </Box>
            <AppRoutes />
          </Layout>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default withTranslation()(App);
